









































import { defineComponent, reactive, ref } from '@vue/composition-api';

import DeliveryTimeStats from '@/components/Report/04-DeliveryTime/DeliveryTimeStats.vue';
import DeliveryDurationBarChart from '@/components/Report/04-DeliveryTime/DeliveryDurationBarChart.vue';
import CommonHubSelector from '@/components/CommonHubSelector.vue';

import deliveryTimeMonths from '@/gql/managementReport/04-DeliveryTime/deliveryTimeMonths.gql';
import useAuth from '@/useAuth';

const DeliveryTime = defineComponent({
  components: {
    DeliveryTimeStats,
    DeliveryDurationBarChart,
    CommonHubSelector,
  },
  setup() {
    const { me } = useAuth();
    const filter = reactive({
      hub: null,
    });

    const yTicks = ref({ stepSize: 1 });

    return {
      me,
      filter,
      deliveryTimeMonths,
      yTicks,
    };
  },
});

export default DeliveryTime;
